import { apiGet, apiPost, apiPatch } from '@/app/api/core/http';
import { SAMPLES_PATHS } from './paths';

// Samples and sample conditions expose the same CRUD shape, only the base url differs
const makeSampleResource = (url) => ({
  getList: (params) => apiGet(url, { params }),
  getLDList: (params) => apiGet(url + SAMPLES_PATHS.suffix, { params }),
  getItem: (id, params) => apiGet(`${url}/${id}`, { params }),
  create: (data) => apiPost(url, { data }),
  update: (id, data) => apiPatch(`${url}/${id}`, { data }),
});

export const samplesApiAdapter = {
  samples: makeSampleResource(SAMPLES_PATHS.samples),
  sampleConditions: makeSampleResource(SAMPLES_PATHS.sampleConditions),
};
